import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import { offerMessage } from 'features/help/constants';
import { useHistory } from 'react-router-dom';
import AgentNetButton from 'ui-kit/components/button/AgentNetButton';
import useStyles from './ListStyles';

interface IDisabledProducts {
  qaPrefix: string;
  description: string;
  productCode: string;
  isAgentNetAdmin?: boolean;
  index: number;
}

const DisabledProducts = ({ qaPrefix, description, productCode, isAgentNetAdmin, index }: IDisabledProducts) => {
  const classes = useStyles();
  const history = useHistory();

  const handleEnable = () => {
    history.push(`/admin/integrations-features?productCode=${productCode}`);
  };

  if (isAgentNetAdmin) {
    return (
      <>
        <Typography variant="body1" className={clsx(classes.marginBottom, classes.typographyFontSize)}>
          {`${description} ${offerMessage['admin']}`}
        </Typography>
        <AgentNetButton
          variant="contained"
          color="primary"
          data-testid={`${qaPrefix}-button-enable-${index}`}
          size="small"
          onClick={handleEnable}
          className={classes.marginTop}
        >
          Enable
        </AgentNetButton>
      </>
    );
  }

  return (
    <Typography variant="body1" className={clsx(classes.marginBottom, classes.typographyFontSize)}>
      {`${description} ${offerMessage['nonAdmin']}`}
    </Typography>
  );
};

export default DisabledProducts;
